import React from 'react';
import { IProps, IState } from './types';
import InsTypeDefinesEN from 'constants/models/insTypeDefinesEN';
import { InsType } from 'constants/enums/insType.enum';
import { insProcessFireStep, insProcessFireStepIcon } from 'constants/enums/insProcessFire.enum';
import ProcessBar from 'components/InsureProcess/ProcessBar';
import { IStepElems } from 'components/InsureProcess/ProcessBar/types';
import InsureProcessBuildingInfo from 'components/InsureProcess/Fire/InsureProcessBuildingInfo';
import InsureProcessSelect from 'components/InsureProcess/Fire/InsureProcessSelect';
import InsureProcessFill from 'components/InsureProcess/Fire/InsureProcessFill';
import InsureProcessPreview from 'components/InsureProcess/Fire/InsureProcessPreview';
import InsureProcessPayment from 'components/InsureProcess/Fire/InsureProcessPayment';
import InsureProcessSuccess from 'components/InsureProcess/Fire/InsureProcessSuccess';
import SliderBoundless from 'components/SliderBoundless';
import service from 'bff/services/fireProdService';
import { IBuildingInfoFormValue, IBuildingInfoState } from 'constants/models/components/insureProcessFire/buildingInfo';
import commonService from 'utils/commonService';
import { storageKeys } from 'constants/enums/storageKeys.enum';
import storageService from 'utils/storageService';
// import moment from 'moment';
import moment from 'moment-timezone';
import { RouterSettings } from 'constants/models/routerSettings';
import {
  InprocessSelectFormValue,
  InprocessSelectState
} from 'constants/models/components/insureProcessFire/insureProcessSelect';
import sweetAlertService from 'utils/sweetAlertService';
import { CodeId } from 'constants/enums/codeId.enum';
import {
  InprocessFillFormValue,
  InprocessFillState
} from 'constants/models/components/insureProcessFire/insureProcessFill';
import { ApplyType } from 'constants/enums/applyType.enum';
import { MemberProfile } from 'bff/models/member';
import { SactionType } from 'constants/enums/sactionType.enum';
import apiCommonService from 'bff/services/commonService';
import OTPVerificationForm from 'components/OTPVerificationForm';
import { OTPInfo } from 'bff/models/login';
import { Activity, Code } from 'bff/models/info';
import { SweetAlertIcon } from 'constants/enums/sweetAlertIcon.enum';
import {
  InsureProcessPaymentFormValue,
  InsureProcessPaymentState
} from 'constants/models/components/insureProcessFire/insureProcessPayment';
import _ from 'lodash';
import { InsureProcessTemp } from 'constants/models/insureProcessTemp';
import { FirePlanItemBaseContent, FirePlanItemIndemnifyContent } from 'bff/models/product';
import { FireItemType } from 'constants/enums/fireItemType';
import { DataLayerArgs } from 'react-gtm-module';
import { helperArgGTM, pushGTM } from 'plugins/gtmService';

class InsureProcessFire extends React.Component<IProps, IState> {
  readonly state: IState = {
    step: 0 as insProcessFireStep,
    insTypeId: '',
    insTypeName: '',
    prodId: '',
    programId: '',
    postcodes: new Array(0),
    UICodes: new Array(0),
    tempBuildingInfo: {},
    tempSelect: {},
    tempFill: {},
    tempPayment: {},
    boPayby: {
      POLICY_FEE: 0,
      INS_TYPE_ID: '',
      APPLY_NO: '',
      BC_TYPE: '',
      PROD_ID: '',
      PAYER_LIST: [],
      END_DATE: '',
      START_DATE: '',
      START_HOUR: '',
      POLICY_DELIVERY: '',
      PROD_NAME: '',
      CO_END_DATE: '',
      CAR_LICENSE: '',
      CO_START_DATE: '',
      VO_START_DATE: '',
      VO_END_DATE: '',
      CAR_SURVEY_STATUS: ''
    }
  }

  private renewalInfo = (this.props.history.location.state as any)?.renewalInfo;

  componentDidMount = async () => {
    if (this.props.match.params.uuid) {
      storageService.removeItem(storageKeys.InsurceProcessFireState);
      const boPaybyRes = await apiCommonService.boPayby(this.props.match.params.uuid);

      if (typeof boPaybyRes === 'string') {
        sweetAlertService.modal({
          icon: SweetAlertIcon.Info,
          html: `${boPaybyRes}`
        }).then(() => {
          this.props.history.replace(RouterSettings.Home);
        });
        return;
      }

      const initSetting = await service.fetchInitSetting();

      this.setState({
        insTypeId: boPaybyRes.INS_TYPE_ID,
        insTypeName: initSetting.inscat.INS_TYPE_NAME,
        prodId: boPaybyRes.PROD_ID,
        boPayby: { ...boPaybyRes },
        UICodes: [...initSetting.UICodes],
        postcodes: [...initSetting.postcodes],
        step: insProcessFireStep.InsureProcessPayment
      });

      return;
    }

    // 險種
    let insTypeIdVal: string = InsType.Fire;
    // 商品 Id
    let prodIdVal: string = '';
    // 專案代碼
    let programIdVal: string = '';
    if (storageService.getItem(storageKeys.FireActiveProdId)) {
      const temp = JSON.parse(storageService.getItem(storageKeys.FireActiveProdId)) as InsureProcessTemp;

      prodIdVal = temp.PROD_ID || '';
      insTypeIdVal = temp.INS_TYPE_ID || InsType.Fire;
      programIdVal = temp.PROGRAM_ID || '';
    }

    // #region 判斷有無暫存資料 進行設值

    // 有暫存資料且暫存資料已到期，或選擇不同商品，刪除暫存資料
    if (storageService.getItem(storageKeys.InsurceProcessFireState)) {
      const tempData = JSON.parse(storageService.getItem(storageKeys.InsurceProcessFireState));

      const isChangeProdId = this.handleValidProdIdChange(insTypeIdVal, prodIdVal, tempData);

      if (isChangeProdId || moment().isAfter(tempData.expiredDate)) {
        storageService.removeItem(storageKeys.InsurceProcessFireState);
      }
    }

    const tempData = JSON.parse(storageService.getItem(storageKeys.InsurceProcessFireState));

    if (tempData) {
      // console.log('設定暫存資料');
      this.setState({
        ...tempData,
        programId: tempData.programId ? tempData.programId : programIdVal
      });
      return;
    }

    // #endregion

    // if (!insTypeIdVal || !prodIdVal) {
    //   this.props.history.push(RouterSettings.Product.FireIns);
    //   return;
    // }

    const initSetting = await service.fetchInitSetting();

    this.setState({
      step: insProcessFireStep.InsureProcessBuildingInfo,
      insTypeId: insTypeIdVal,
      insTypeName: initSetting.inscat.INS_TYPE_NAME,
      prodId: prodIdVal,
      UICodes: [...initSetting.UICodes],
      postcodes: [...initSetting.postcodes],
      programId: programIdVal
    });

    // const initSettingRes = await service.fetchTempFireState();
    // this.setState({ ...initSettingRes });
  }

  /**
   * @description 判斷選取的方案是否改變，決定是否清除暫存
  */
  handleValidProdIdChange = (insTypeId: string, prodId: string, tempData: any) => {
    const selectState = tempData.tempSelect.tempSelectState as InprocessSelectState;

    // 未執行到商品選擇頁，判斷選取的商品卡片是否更改 或
    // 執行到商品選擇頁， 未選取方案，判斷選取的商品卡片是否更改
    if (!selectState || Object.keys(selectState).length === 0 || (selectState && !selectState.activeProdId)) {
      return insTypeId !== tempData.insTypeId || prodId !== tempData.prodId;
    }

    // activePlan activeProdId prodId
    // 執行到商品選擇頁，判斷選取的方案是否和商品卡片不符
    return insTypeId !== tempData.insTypeId || prodId !== selectState.activeProdId;
  }

  /**
   * @description 填寫房屋資料頁面結束事件
  */
  handleBuildingInfoUnmount = (formVal: IBuildingInfoFormValue, state: IBuildingInfoState) => {
    const newState = {
      ...this.state,
      tempBuildingInfo: {
        tempBuildingInfoFormValue: { ...formVal },
        tempBuildingInfoState: { ...state }
      }
    };

    commonService.storageData(storageKeys.InsurceProcessFireState, newState);
  }

  /**
   * @description 填寫房屋資料頁面結束事件
  */
  handleBuildingInfoSubmit = (formVal: IBuildingInfoFormValue, state: IBuildingInfoState) => {
    this.setState({
      step: insProcessFireStep.InsureProcessSelect,
      tempBuildingInfo: {
        tempBuildingInfoFormValue: { ...formVal },
        tempBuildingInfoState: { ...state }
      }
    });
  }

  /**
   * @description 商品選擇頁返回上一頁事件
  */
  handleInprocessSelectGoBack = (formVal: InprocessSelectFormValue, state: InprocessSelectState, activeProdId: string) => {
    this.setState({
      step: insProcessFireStep.InsureProcessBuildingInfo,
      tempSelect: {
        tempSelectFormValue: { ...formVal },
        tempSelectState: { ...state }
      },
      prodId: activeProdId
    });
  }

  handleInprocessSelectCalc = (formVal: InprocessSelectFormValue, state: InprocessSelectState) => {
    this.setState({
      tempSelect: {
        tempSelectFormValue: { ...formVal },
        tempSelectState: { ...state }
      }
    });

    pushGTM(this.getGtmArg('add_to_cart'));
  }

  /**
   * @description 商品選擇頁 Submit 事件
  */
  handleInprocessSelectSubmit = (formVal: InprocessSelectFormValue, state: InprocessSelectState) => {
    if (storageService.getItem(storageKeys.MemberId)) {
      this.setState({
        step: insProcessFireStep.InsureProcessFill,
        tempSelect: {
          tempSelectFormValue: { ...formVal },
          tempSelectState: { ...state }
        }
      });

      return;
    }

    // 則呈現Lightbox提示 是否要登入? ，提供確定、取消供客戶執行
    sweetAlertService.modal({
      html: `${commonService.getCodeMsg(this.state.UICodes, CodeId.W007)} <br /> ${commonService.getCodeMsg(this.state.UICodes, CodeId.W009)}`,
      showCancelButton: true,
      showCloseButton: true
    }).then(async res => {
      if (res.value) {
        this.setState({
          step: 0 as insProcessFireStep,
          tempSelect: {
            tempSelectFormValue: { ...formVal },
            tempSelectState: { ...state }
          }
        });

        const path = {
          pathname: RouterSettings.Login,
          state: { originUrl: RouterSettings.InsureProcess.Fire }
        };

        this.props.history.push(path);
      }
      if (res.dismiss) {
        this.setState({
          step: insProcessFireStep.InsureProcessFill,
          tempSelect: {
            tempSelectFormValue: { ...formVal },
            tempSelectState: { ...state }
          }
        });
      }
    });
  }

  /**
   * @description 商品選擇頁頁面結束事件
  */
  handleInprocessSelectUnmount = (formVal: InprocessSelectFormValue, state: InprocessSelectState) => {
    const newState = {
      ...this.state,
      step: this.state.step ? this.state.step : insProcessFireStep.InsureProcessFill,
      tempSelect: {
        tempSelectFormValue: { ...formVal },
        tempSelectState: { ...state }
      }
    };

    if (this.state.step === insProcessFireStep.InsureProcessFill) {
      pushGTM(this.getGtmArg('begin_checkout'));
    }

    commonService.storageData(storageKeys.InsurceProcessFireState, newState);
  }

  /**
   * @description 填寫資料頁頁面結束事件
  */
  handleInprocessFillUnmount = (formVal: InprocessFillFormValue, state: InprocessFillState) => {
    const newState = {
      ...this.state,
      tempFill: {
        tempFillFormValue: { ...formVal },
        tempFillState: { ...state }
      }
    };
    commonService.storageData(storageKeys.InsurceProcessFireState, newState);
  }

  /**
   * @description 填寫資料頁返回上一頁事件
  */
  handleInprocessFillGoBack = (formVal: InprocessFillFormValue, state: InprocessFillState) => {
    this.setState({
      step: insProcessFireStep.InsureProcessSelect,
      tempFill: {
        tempFillFormValue: { ...formVal },
        tempFillState: { ...state }
      }
    });
  }

  /**
   * @description 填寫資料頁 Submit 事件
  */
  handleInprocessFillSubmit = (formVal: InprocessFillFormValue, state: InprocessFillState) => {
    this.setState({
      step: insProcessFireStep.InsureProcessPreview,
      tempFill: {
        tempFillFormValue: { ...formVal },
        tempFillState: { ...state }
      }
    });
  }

  /**
   * @description 資料預覽頁返回上一頁事件
  */
  handleInprocessPreviewGoBack = () => {
    this.setState({
      step: insProcessFireStep.InsureProcessFill
    });
  }

  /**
   * @description 資料預覽頁點選下一步事件
  */
  handleInprocessPreviewSubmit = async () => {
    const applyType: string = this.state.tempFill.tempFillState?.applyType || '';

    // 案件來源為網投進行 OTP 驗證後再導至付款頁
    if (applyType === ApplyType.WebInsured) {
      // 進行 OTP
      await this.handleFetchOTP(false);

      return;
    }

    this.setState({
      step: insProcessFireStep.InsureProcessPayment
    });
  }

  /**
   * @description 取得 OTP 驗證碼方法
   * @param memberProfile 會員基本資料
   * @param isReSent 是否為重新發送
  */
  handleFetchOTP = async (isReSent?: boolean) => {
    const tempFillFormVal = { ...this.state.tempFill.tempFillFormValue } as InprocessFillFormValue;
    const memberId = tempFillFormVal.POLICYHOLDERS[0].POLICYHOLDER_ID;
    const mobile = tempFillFormVal.POLICYHOLDERS[0].POLICYHOLDER_MOBILE;
    const emailAddr = tempFillFormVal.POLICYHOLDERS[0].POLICYHOLDER_EMAIL_ADDR;

    const result = await apiCommonService.fetchOTP({ MEMBER_ID: memberId, MOBILE: mobile, EMAIL_ADDR: emailAddr } as MemberProfile, SactionType.Insurce, isReSent);
    if (result) {
      this.setState({
        step: insProcessFireStep.InsureProcessVerifyOTP,
        otpInfo: { ...result.TRANRS },
        getOTPTime: new Date().getTime()
      });
    }
  }

  /**
   * @description OTP 驗證碼頁面點選返回上一頁或無法取得驗證碼時的方法
   */
  handleReSetProfile = () => {
    this.setState({
      step: insProcessFireStep.InsureProcessPreview,
      otpInfo: undefined,
      getOTPTime: undefined
    });
  };

  /**
   * @description 驗證 OTP 驗證碼方法
   * @param otpVerificationReq OTP 驗證頁 Request Model
  */
  handleVerifyOTP = async (otpCode: string) => {
    const result = await apiCommonService.verifyOTP(this.state.otpInfo as OTPInfo, otpCode, SactionType.Insurce, false);

    if (typeof result === 'string') {
      sweetAlertService.modal({
        icon: SweetAlertIcon.Info,
        title: '驗證碼輸入有誤'
      });

      return;
    }

    if (result) {
      this.setState({
        step: insProcessFireStep.InsureProcessPayment
      });
    }
  }

  /**
   * @description 確認付款頁返回上一頁事件
  */
  handleInprocessPaymentGoBack = () => {
    this.setState({
      step: insProcessFireStep.InsureProcessPreview
      // tempPayment: {
      //   tempPaymentFormValue: { ...formVal },
      //   tempPaymentState: { ...state }
      // }
    });
  }

  /**
   * @description 確認付款頁頁面結束事件
  */
  handleInprocessPaymentUnmount = (formVal: InsureProcessPaymentFormValue, state: InsureProcessPaymentState) => {
    const newState = {
      ...this.state,
      tempPayment: {
        tempPaymentFormValue: { ...formVal },
        tempPaymentState: { ...state }
      }
    };

    commonService.storageData(storageKeys.InsurceProcessFireState, newState);
  }

  /**
   * @description 確認付款頁 Submit 事件
  */
  handleInprocessPaymentSubmit = async (formVal: InsureProcessPaymentFormValue, state: InsureProcessPaymentState) => {
    const activityInfo = await service.fetchActivities(InsType.Fire);

    this.setState({
      step: insProcessFireStep.InsureProcessSuccess,
      tempPayment: {
        tempPaymentFormValue: { ...formVal },
        tempPaymentState: { ...state }
      },
      activities: { ...activityInfo.activities }
    });

    pushGTM(this.getGtmArg('purchase'));

    storageService.removeItem(storageKeys.InsurceProcessFireState);
    storageService.removeItem(storageKeys.FireActiveProdId);
  }

  getPolicyItem = () => {
    const itemsReq = new Array(0);
    _.forEach(this.state.tempSelect.tempSelectFormValue?.POLICY_ITEMS, (policyItem: FirePlanItemBaseContent) => {
      if (policyItem.ITEM_OPTIONAL === FireItemType.ITEM_CHECKBOX_SHOW && !policyItem.CHECKED) return;
      const item: any = {
        ITEM_ID: policyItem.ITEM_ID,
        ITEM_NAME: policyItem.ITEM_NAME,
        VARIANT: `${policyItem.ITEM_NAME}:`
      };
      const coverages:string[] = [];
      _.forEach(policyItem.INDEMNIFYS, (indemnify: FirePlanItemIndemnifyContent) => {
        if (indemnify.INS_COVERAGE_OPTION && indemnify.INS_COVERAGE_OPTION.length > 0) {
          coverages.push(indemnify.INS_COVERAGE_OPTION.reduce((coverages: string[], coverageOption: any) => {
            switch (coverageOption.TYPE) {
              case FireItemType.TYPE_SHOW:
                coverages.push(coverageOption.SHOW_VALUE);
                break;
              case FireItemType.TYPE_INPUT:
                coverages.push(coverageOption.INPUT_VALUE);
                break;
              case FireItemType.TYPE_OPTION:
                coverages.push(coverageOption.SELECT_TEXT);
                break;
            }
            return coverages;
          }, []).join('/'));
        }
      });
      item.VARIANT += coverages.join('/');
      itemsReq.push(item);
    });

    return itemsReq;
  }

  getGtmArg = (event:string): DataLayerArgs => {
    // 取得有投保的項目
    const insuredPolicys = this.getPolicyItem();
    return {
      dataLayer: {
        event: 'td_' + event,
        ga4_event_name: event,
        ecommerce: {
          ...event === 'purchase' ? {
            coupon: this.state.tempBuildingInfo.tempBuildingInfoFormValue?.PROGRAM_ID || null,
            transaction_id: this.state.tempFill.tempFillState?.serialNo,
            affiliation: helperArgGTM.getAffiliation,
            payment_method: helperArgGTM.getPaymentMethodText(this.state.tempPayment.tempPaymentFormValue?.PAYMENT_METHOD)
          } : {},
          currency: helperArgGTM.getCurrency,
          value: this.state.tempSelect.tempSelectState?.evalFireRes.TOTAL_FEE ?? 0,
          items: insuredPolicys.map((item: any) => ({
            item_id: item.ITEM_ID,
            item_name: item.ITEM_NAME,
            affiliation: helperArgGTM.getAffiliation,
            coupon: this.state.tempBuildingInfo.tempBuildingInfoFormValue?.PROGRAM_ID || null,
            currency: 'TWD',
            item_brand: this.state.insTypeName,
            item_category: this.state.insTypeName,
            item_category2: helperArgGTM.getRenewOrNewText(this.state.tempBuildingInfo.tempBuildingInfoFormValue?.REPOLICY_NO),
            item_category3: helperArgGTM.getBcTypeText(this.state.tempFill.tempFillState?.applyType),
            item_variant: item.VARIANT,
            price: this.state.tempSelect.tempSelectState?.evalFireRes.ITEMS
                .reduce((acc, policyItem: any) => {
                  if (policyItem.ITEM_ID === item.ITEM_ID) {
                    return acc + (policyItem?.FEE || 0);
                  }
                  return acc;
                }, 0),
            quantity: 1,
            item_list_name: this.state.tempSelect.tempSelectState?.activePlanName
          }))
        }
      }
    };
  }

  render () {
    const { step } = this.state;

    const tempFillFormVal = { ...this.state.tempFill.tempFillFormValue } as InprocessFillFormValue;
    let memberId = '';
    let mobile = '';
    let emailAddr = '';
    if (tempFillFormVal && tempFillFormVal.POLICYHOLDERS && tempFillFormVal.POLICYHOLDERS.length > 0) {
      memberId = tempFillFormVal.POLICYHOLDERS[0].POLICYHOLDER_ID;
      mobile = tempFillFormVal.POLICYHOLDERS[0].POLICYHOLDER_MOBILE;
      emailAddr = tempFillFormVal.POLICYHOLDERS[0].POLICYHOLDER_EMAIL_ADDR;
    }

    const stepElems: IStepElems[] = [
      {
        icon: insProcessFireStepIcon.buildingIcon,
        text: '建築物資料',
        active: step >= insProcessFireStep.InsureProcessBuildingInfo,
        mobileActive: step === insProcessFireStep.InsureProcessBuildingInfo
      },
      {
        icon: insProcessFireStepIcon.selectIcon,
        text: '選擇商品',
        active: step >= insProcessFireStep.InsureProcessSelect,
        mobileActive: step === insProcessFireStep.InsureProcessSelect
      },
      {
        icon: insProcessFireStepIcon.fillIcon,
        text: '填寫資料',
        active: step >= insProcessFireStep.InsureProcessFill,
        mobileActive: step === insProcessFireStep.InsureProcessFill
      },
      {
        icon: insProcessFireStepIcon.previewIcon,
        text: '資料預覽',
        active: step >= insProcessFireStep.InsureProcessPreview,
        mobileActive: step === insProcessFireStep.InsureProcessPreview
      },
      {
        icon: insProcessFireStepIcon.paymentIcon,
        text: '確認付款',
        active: step >= insProcessFireStep.InsureProcessPayment,
        mobileActive: step === insProcessFireStep.InsureProcessPayment
      },
      {
        icon: insProcessFireStepIcon.successIcon,
        text: '成功投保',
        active: step >= insProcessFireStep.InsureProcessSuccess,
        mobileActive: step === insProcessFireStep.InsureProcessSuccess
      }
    ];

    return (
      <div className={`insure-process insure-process--${InsTypeDefinesEN[InsType.Fire]}`}>
        <div className="insure-process__header">
          <ProcessBar
            insType={InsTypeDefinesEN[InsType.Fire]}
            stepElems={stepElems}
          />
        </div>
        <div className="insure-process__content">
          <div className="template-container">
            <div className="template-content">
              {/* 建築物資料 */}
              {step === insProcessFireStep.InsureProcessBuildingInfo && (
                <InsureProcessBuildingInfo
                  postcodes={this.state.postcodes}
                  UICodes={this.state.UICodes}
                  onSubmit={this.handleBuildingInfoSubmit}
                  onUnmount={this.handleBuildingInfoUnmount}
                  tempBuildingInfo={this.state.tempBuildingInfo}
                  tempState={this.state}
                  renewalInfo={this.renewalInfo}
                  insTypeId={this.state.insTypeId}
                  programId={this.state.programId}
                />
              )}
              {/* 選擇商品 */}
              {step === insProcessFireStep.InsureProcessSelect && (
                <InsureProcessSelect
                  insTypeId={this.state.insTypeId}
                  prodId={this.state.prodId}
                  UICodes={this.state.UICodes}
                  tempBuildingInfo={this.state.tempBuildingInfo}
                  tempSelect={this.state.tempSelect}
                  tempState={this.state}
                  onCalc={this.handleInprocessSelectCalc}
                  onSubmit={this.handleInprocessSelectSubmit}
                  onGoBack={this.handleInprocessSelectGoBack}
                  onUnmount={this.handleInprocessSelectUnmount}
                />
              )}
              {/* 填寫資料 */}
              {step === insProcessFireStep.InsureProcessFill && (
                <InsureProcessFill
                  insTypeId={this.state.insTypeId}
                  postcodes={this.state.postcodes}
                  UICodes={this.state.UICodes}
                  tempBuildingInfo={this.state.tempBuildingInfo}
                  tempSelect={this.state.tempSelect}
                  tempFill={this.state.tempFill}
                  tempState={this.state}
                  onGoBack={this.handleInprocessFillGoBack}
                  onSubmit={this.handleInprocessFillSubmit}
                  onUnmount={this.handleInprocessFillUnmount}
                />
              )}
              {/* 資料預覽 */}
              {step === insProcessFireStep.InsureProcessPreview && (
                <InsureProcessPreview
                  insTypeId={this.state.insTypeId}
                  tempBuildingInfo={this.state.tempBuildingInfo}
                  tempSelect={this.state.tempSelect}
                  tempFill={this.state.tempFill}
                  onSubmit={this.handleInprocessPreviewSubmit}
                  onGoBack={this.handleInprocessPreviewGoBack}
                  tempState={this.state}
                />
              )}
              {/* OTP 檢核頁 */}
              {
                step === insProcessFireStep.InsureProcessVerifyOTP && (
                  <OTPVerificationForm
                    memberProfile={{ MEMBER_ID: memberId, MOBILE: mobile, EMAIL_ADDR: emailAddr } as MemberProfile}
                    memberId={memberId}
                    otpInfo={this.state.otpInfo as OTPInfo}
                    getOTPTime={this.state.getOTPTime as number}
                    UICode={this.state.UICodes as Code[]}
                    onUnavailableAuth={this.handleReSetProfile}
                    onGoBack={this.handleReSetProfile}
                    onSubmit={this.handleVerifyOTP}
                    onResentOTP={() => this.handleFetchOTP(true)}
                  // eslint-disable-next-line react/jsx-closing-bracket-location
                  />
                )
              }
              {/* 確認付款 */}
              {step === insProcessFireStep.InsureProcessPayment && (
                <InsureProcessPayment
                  insTypeId={this.state.insTypeId}
                  UICodes={this.state.UICodes}
                  onSubmit={this.handleInprocessPaymentSubmit}
                  onUnmount={this.handleInprocessPaymentUnmount}
                  onGoBack={this.handleInprocessPaymentGoBack}
                  tempBuildingInfo={this.state.tempBuildingInfo}
                  tempSelect={this.state.tempSelect}
                  tempFill={this.state.tempFill}
                  tempPayment={this.state.tempPayment}
                  tempState={this.state}
                  boPayby={this.state.boPayby}
                />
              )}
              {/* 成功投保 */}
              {step === insProcessFireStep.InsureProcessSuccess && (
                <InsureProcessSuccess
                  tempBuildingInfo={this.state.tempBuildingInfo}
                  tempSelect={this.state.tempSelect}
                  tempFill={this.state.tempFill}
                  tempPayment={this.state.tempPayment}
                  tempState={this.state}
                  boPayby={this.state.boPayby}
                />
              )}
            </div>
          </div>
        </div>
        {/* 成功投保 (Slider) */}
        {step === insProcessFireStep.InsureProcessSuccess && this.state.activities && this.state.activities.ACTIVITY.length > 0 && (
          <div className="insure-process__slider-section">
            <SliderBoundless name="insure-process-car-success-slider">
              {
                _.map(this.state.activities.ACTIVITY, (activity: Activity, index: number) => {
                  return (
                    <SliderBoundless.Item key={index}>
                      <a href={activity.ACTIVITY_URL} target="_blank" rel="noopener noreferrer">
                        <img src={activity.IMAGE_NAME_PC} alt={activity.TITLE} />
                      </a>
                    </SliderBoundless.Item>
                  );
                })
              }
            </SliderBoundless>
          </div>
        )}
      </div>
    );
  }
}

export default InsureProcessFire;
